import { ROUTE_PATHS } from '@configs/route-paths.const';

import { Menu } from '@models/view/menu.model';

export const AppMenus: Menu = {
  PORTFOLIO: {
    open: false,
    label: 'Portfolio Monitoring',
    icon: 'phosphorChartLineUp',
    path: '/dashboard/portfolio',
    subitems: [
      {
        requiredPermissions: ['PORTFOLIO_OVERVIEW_READ'],
        label: 'Overview',
        icon: 'phosphorSquaresFour',
        path: '/dashboard/portfolio/overview',
      },
      {
        requiredPermissions: ['PORTFOLIO_FACILITIES_READ'],
        label: 'Facilities',
        icon: 'phosphorCube',
        path: '/dashboard/portfolio/facilities',
        activePaths: [
          '/dashboard/portfolio/facilities',
          '/dashboard/portfolio/facility',
        ],
      },
    ],
  },
  FINANCIAL: {
    open: false,
    label: 'Financials',
    icon: 'phosphorFileMoney',
    path: '/dashboard/financials',
    subitems: [
      {
        requiredPermissions: ['FINANCIAL_COVENANTS_READ'],
        label: 'Covenants',
        icon: 'phosphorCheckSquareOffset',
        path: '/dashboard/financials/covenants',
      },
      {
        requiredPermissions: ['FINANCIAL_KEYFINANCIALS_READ'],
        label: 'Key Financials',
        icon: 'phosphorCurrencyCircleDollar',
        path: '/dashboard/financials/key-financials',
        activePaths: [
          '/dashboard/financials/covenants',
          '/dashboard/financials/key-financials',
        ],
      },
    ],
  },
  COMPANY: {
    open: false,
    label: 'Companies',
    icon: 'phosphorBuildingOffice',
    path: '/dashboard/companies',
    subitems: [],
    requiredPermissions: ['COMPANY_COMPANIES_READ'],
    paintRow: true,
  },
  DATA_STUDIO: {
    open: false,
    label: 'Data Studio',
    icon: 'phosphorTreeStructure',
    path: '/dashboard/data-studio',
    subitems: [
      {
        requiredPermissions: ['DATA_STUDIO_DATAFLOW_READ'],
        label: 'Data Flow',
        icon: 'phosphorStepsSquare',
        path: '/dashboard/data-studio/data-flow',
      },
      {
        requiredPermissions: ['DATA_STUDIO_DATAPOINTS_READ'],
        label: 'Data Points',
        icon: 'phosphorHardDrives',
        path: '/dashboard/data-studio/data-points',
      },
    ],
  },
  RUG: {
    open: false,
    label: 'RUG Smart Search',
    icon: 'phosphorVerifiedSearch',
    path: '/dashboard/rug',
    subitems: [
      {
        label: 'Advanced Search',
        icon: 'phosphorListMagnifyingGlass',
        path: '/dashboard/rug/smart-search',
      },
      {
        label: 'Tracking',
        icon: 'phosphorEyeFocus',
        path: '/dashboard/rug/tracking',
      },
      {
        requiredPermissions: ['RUG_ASSET_VERIFICATION_VIEW'],
        label: 'Asset Verification',
        icon: 'phosphorCertificate',
        path: '/dashboard/rug/asset-verification',
      },
    ],
  },
  AIVA: {
    open: false,
    label: 'AI Verification Agent',
    icon: 'phosphorClipboardText',
    path: '/dashboard/aiva',
    subitems: [
      {
        requiredPermissions: ['AIVA_LAUNCH_BATCH_VIEW'],
        label: 'Launch Batch',
        icon: 'phosphorPlayCircle',
        path: '/dashboard/aiva/launch',
      },
      {
        requiredPermissions: ['AIVA_ACTIVITY_VIEW'],
        label: 'Activity',
        icon: 'phosphorClockCounterClockwise',
        path: '/dashboard/aiva/activity',
      },
      {
        requiredPermissions: ['AIVA_REVIEW_QUEUE_VIEW'],
        label: 'Review Queue',
        icon: 'phosphorListChecks',
        path: '/dashboard/aiva/review-queue',
      },
      {
        requiredPermissions: ['AIVA_SELF_SERVICE_TOOL_VIEW'],
        label: 'Self Service Tool',
        icon: 'phosphorFileCog',
        path: ROUTE_PATHS.SELF_SERVICE_TOOL,
      },
    ],
  },
  SHELL_ADMIN: {
    open: false,
    label: 'Admin',
    icon: 'phosphorUserCircleGear',
    path: '/dashboard/admin',
    subitems: [],
    paintRow: true,
  },
};
